import { useRef, useEffect } from 'react';

import { VStack, HStack, Paragraph, Box } from '@vimeo/bokeh';
import { TrashBin } from '@vimeo/bokeh-icons';

import { T } from '../../translations';

export interface DeletedCommentProps {
  isDeeplinkedComment?: boolean;
}

export const DeletedComment = ({ isDeeplinkedComment = false }: DeletedCommentProps) => {
  const deeplinkedCommentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isDeeplinkedComment) return;
    const timeoutId = setTimeout(() => {
      deeplinkedCommentRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [isDeeplinkedComment]);

  return (
    <HStack
      spacing={75}
      align="flex-start"
      px={{ base: 200, md: 300 }}
      py={75}
      role="group"
      data-testid="comment"
      ref={isDeeplinkedComment ? deeplinkedCommentRef : null}
    >
      <Box
        backgroundColor="fill-component"
        boxSize="sm"
        borderRadius="50%"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <TrashBin m="4px" boxSize="20px" />
      </Box>
      <VStack spacing={75} minW={0} align="stretch" flex={1}>
        <HStack spacing={75}>
          <Paragraph size="md" color="text-secondary" p="6px 0">
            {T.DeletedComment}
          </Paragraph>
        </HStack>
      </VStack>
    </HStack>
  );
};
